import AllWinsMediator from "slotworks/mediators/all-wins-mediator";
import State from "slotworks/state-machine/states/state";

export default class HighlightWins extends State {
    public onEnter() {
        const allWinsMediator = new AllWinsMediator();

        allWinsMediator.start().then(() => this.complete());
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/state-machine/standard/states/highlight-wins.ts